module.exports = __webpack_public_path__ + "assets/0f6c4197fae87a0433d734b98174314a.mp4";